export const importSummary = {
  file: 'BRTA_CNG_DMP_Batch_03_Mar2026.xlsx',
  total: 2450,
  success: 2318,
  duplicate: 64,
  incomplete: 47,
  error: 21
};

export const importPreview = [
  { row: 1, reg: 'ঢাকা-থ-১৪-২২১৯', owner: 'মোঃ নজরুল ইসলাম', chassis: 'MDH12F45ABL221977', fitness: '১৫ আগস্ট ২০২৭', status: 'সফল' },
  { row: 2, reg: 'ঢাকা-থ-১৩-৭৮৯০', owner: 'মোসাঃ শাহনাজ বেগম', chassis: 'MDH12F45ABE789034', fitness: '১০ মার্চ ২০২৬', status: 'সফল' },
  { row: 3, reg: 'ঢাকা-থ-১৩-১১২২', owner: 'মোঃ ইউসুফ আলী', chassis: 'MDH12F45ABK112298', fitness: '০২ জুন ২০২৭', status: 'সফল' },
  { row: 4, reg: 'ঢাকা-থ-১১-১২৩৪', owner: 'মোঃ রহিম উদ্দিন', chassis: 'MDH12F45ABC123456', fitness: '৩০ জুন ২০২৭', status: 'ডুপ্লিকেট' },
  { row: 5, reg: 'ঢাকা-থ-১৬-০৪৫১', owner: 'মোঃ আবুল কাশেম', chassis: '—', fitness: '২২ মে ২০২৭', status: 'তথ্য অসম্পূর্ণ' },
  { row: 6, reg: 'ঢাকা-থ-১৬-০৪৫২', owner: 'মোঃ মোস্তফা কামাল', chassis: 'MDH12F45ABP045299', fitness: '৩১/১৩/২০২৭', status: 'ত্রুটিপূর্ণ' },
  { row: 7, reg: 'ঢাকা-থ-১৬-০৪৬০', owner: 'মোঃ আব্দুর রাজ্জাক', chassis: 'MDH12F45ABP046011', fitness: '০৯ জানুয়ারি ২০২৮', status: 'সফল' },
  { row: 8, reg: 'ঢাকা-থ-১৬-০৪৬৩', owner: 'মোসাঃ রোকসানা খাতুন', chassis: 'MDH12F45ABP046344', fitness: '১৮ অক্টোবর ২০২৭', status: 'সফল' }
];

export const importHistory = [
  { batch: 'BRTA-IMP-2026-002', date: '১১ মার্চ ২০২৬', records: '২,৪৫০', success: '২,৩১৮', by: 'নুসরাত জাহান' },
  { batch: 'BRTA-IMP-2026-001', date: '১৫ ফেব্রুয়ারি ২০২৬', records: '১৪,৮২০', success: '১৪,৬০৬', by: 'নুসরাত জাহান' }
];

export const apiServices = [
  { name: 'Vehicle Registration API', bn: 'যানবাহন নিবন্ধন', endpoint: '/v1/vehicles/registration', last: '১২ মার্চ ২০২৬, ১০:০০', success: 16982, failed: 6, pending: 12, uptime: '৯৯.৯৭%' },
  { name: 'Fitness API', bn: 'ফিটনেস সনদ', endpoint: '/v1/vehicles/fitness', last: '১২ মার্চ ২০২৬, ১০:০০', success: 16874, failed: 18, pending: 108, uptime: '৯৯.৮২%' },
  { name: 'Tax Token API', bn: 'ট্যাক্স টোকেন', endpoint: '/v1/vehicles/tax-token', last: '১২ মার্চ ২০২৬, ০৯:৩০', success: 16790, failed: 25, pending: 185, uptime: '৯৯.৬৫%' },
  { name: 'Driving License API', bn: 'ড্রাইভিং লাইসেন্স', endpoint: '/v1/drivers/license', last: '১২ মার্চ ২০২৬, ১০:০০', success: 38412, failed: 41, pending: 220, uptime: '৯৯.৯১%' },
  { name: 'Owner Information API', bn: 'মালিকের তথ্য', endpoint: '/v1/vehicles/owner', last: '১২ মার্চ ২০২৬, ০৯:০০', success: 16950, failed: 9, pending: 41, uptime: '৯৯.৯৪%' }
];
